// ADDED
import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import UndoIcon from '@mui/icons-material/Undo';
import { LeaveIncentiveBatchStatus } from "../../../../../utils/enums";

const LeaveIncentiveBatchTable = ({ data, onEdit, onView, onProcess, onRevert, loading, currentPage, setCurrentPage }) => {
  const headers = ["ID", "Year", "Month", "Status", "Actions"];
  const accessors = ["id", "year", "monthName", "status", "actions"];

  const actions = [
    {
      name: "Process",
      icon: <PlayArrowIcon fontSize="small" />,
      className: "bg-blue-600 hover:bg-blue-700 text-white",
      function: onProcess,
      visible: (item) => item.status === LeaveIncentiveBatchStatus.DRAFT,
    },
    {
      name: "Revert",
      icon: <UndoIcon fontSize="small" />,
      className: "bg-orange-500 hover:bg-orange-600 text-white",
      function: onRevert,
      visible: (item) => item.status === LeaveIncentiveBatchStatus.PROCESSED,
    },
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 text-white",
      function: onEdit,
      visible: (item) => item.status === LeaveIncentiveBatchStatus.DRAFT,
    },
    {
      name: "View",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-gray-500 hover:bg-gray-600 text-white",
      function: onView,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName="Leave Incentive Batches"
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
    />
  );
};

export default LeaveIncentiveBatchTable;